import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import RegattaAdminRequestsSectionView from './RegattaAdminRequestsSectionView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './RegattaAdminRequestsSectionView';

const mapStateToProps = ({
  main,
}: $State): $StateProps => ({
  main,
});

const mapDispatchToProps = (): $DispatchProps => Object.freeze({
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(RegattaAdminRequestsSectionView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
